import { FormikProps } from 'formik';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Expandable } from '../../shared/Expandable';
import { ExpandControlChevron } from '../../shared/ExpandControlChevron';
import { SearchSelectOptions } from '../../shared/form/inputs/SearchSelect';
import { Header3 } from '../../shared/Headers';
import { spacing01, spacing02, spacing04 } from '../../styling/spacing';
import { BillOfMaterialsItemsFieldNames } from './billOfMaterialsItemFormModel';
import { BillOfMaterialsItemsField } from './BillOfMaterialsItemsField';
import { BillOfMaterialsUnitFormModel } from './billOfMaterialsUnitFormModel';
import { BillOfMaterialsPartsById } from './dataForEditBillOfMaterialsForm';

type Props<TFormModel> = {
  unit: BillOfMaterialsUnitFormModel;
  unitIndex: number;
  itemsFieldName: BillOfMaterialsItemsFieldNames;
  partsById: BillOfMaterialsPartsById;
  partsOptions: SearchSelectOptions<number | null>;
  setFieldValue: FormikProps<TFormModel>['setFieldValue'];
  setFieldTouched: FormikProps<TFormModel>['setFieldTouched'];
  errors: FormikProps<TFormModel>['errors'];
  isQuote: boolean;
};

export const BillOfMaterialsUnitFields = <TFormModel,>({
  unit,
  unitIndex,
  itemsFieldName,
  partsById,
  partsOptions,
  setFieldValue,
  setFieldTouched,
  errors,
  isQuote,
}: Props<TFormModel>) => {
  const [isExpanded, setIsExpanded] = useState(!isQuote);

  return (
    <UnitContainer>
      <BillOfMaterialsUnitHeader>
        <ExpandControlChevron isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)} />
        <Header3>{unit.name}</Header3>
      </BillOfMaterialsUnitHeader>
      <Expandable isExpanded={isExpanded} animationDurationSeconds={0.5}>
        <Section>
          <BillOfMaterialsItemsField
            itemsFieldName={`units.${unitIndex}.${itemsFieldName}`}
            items={unit[itemsFieldName]}
            partsById={partsById}
            partsOptions={partsOptions}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            errors={errors}
          />
        </Section>
      </Expandable>
    </UnitContainer>
  );
};

const UnitContainer = styled.div`
  padding: ${spacing04} 0;
`;

const BillOfMaterialsUnitHeader = styled.div`
  display: flex;
  align-items: center;

  ${Header3} {
    margin: 0 0 ${spacing01} ${spacing02};
  }
`;

const Section = styled.div`
  margin-top: ${spacing04};
`;
